<template>
  <div class="text-left">
    <div>
      <p
        v-if="Number(carrierRate) > 0"
        class="mb-5 mt-4 text-dark-gray sm:mt-2 sm:text-sm"
      >
        Confirm your TriumphPay Select Carrier Program payment details.
      </p>
      <p
        v-else
        class="mb-5 mt-4 text-dark-gray sm:mt-2 sm:text-sm"
      >
        Confirm your payment details from TriumphPay.
      </p>
      <div
        class="rounded-1 flex w-full flex-row justify-between rounded border-2 p-4"
      >
        <div>
          <div v-if="Number(carrierRate) > 0">
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Term: Select Carrier Rate
            </label>
            <p class="text-dark-gray">
              QuickPay ({{ Number(carrierRate) * 100 }}%)
            </p>
          </div>
          <div v-else-if="opPaymentTerm?.id > 0">
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Term
            </label>
            <p class="text-dark-gray">
              {{ opPaymentTerm?.name }} ({{ feesToText(opPaymentTerm) }})
            </p>
          </div>
          <label class="text-2xs font-bold uppercase text-gray-over-dark">
            Method
          </label>
          <p class="text-dark-gray">
            {{ getMethod(destinationWallet) }}
          </p>
          <template v-if="destinationWallet === 'check'">
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Address
            </label>
            <p class="text-dark-gray">
              {{
                `${payInfo?.triumph_pay_wallet_address_first_five}*****, ${payInfo?.triumph_pay_wallet_remit_city},  ${payInfo?.triumph_pay_wallet_remit_state}`
              }}
            </p>
          </template>
          <template v-else>
            <label class="text-2xs font-bold uppercase text-gray-over-dark">
              Bank Account Number
            </label>
            <p class="text-dark-gray">
              {{ 'XXXXXX' + payInfo?.triumph_pay_wallet_account_last_four }}
            </p>
          </template>
        </div>
        <div>
          <img
            v-if="Number(carrierRate) > 0"
            class="mt-3"
            src="@/assets/triumphpay-select-carrier.svg"
            title="TriumphPay Select Carrier"
          />
          <img
            v-else
            class="mt-3"
            src="@/assets/triumphpay-no-select-carrier.svg"
          />
        </div>
      </div>
      <p class="mt-5 text-xs leading-4 text-body-color">
        Note: You may edit the payment information provided in this connection
        to {{ brokerName }}, but you must contact TriumphPay directly to update
        your TriumphPay details.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TriumphPay',
  props: {
    payment: Object,
  },
  data() {
    return {
      latest_factor: null,
      factorDataAvailable: true,
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading.isLoading;
    },
    carrierRate() {
      return this.payment?.[0]?.triumph_pay_select_carrier_rate;
    },
    destinationWallet() {
      return this.payment?.[0]?.triumph_pay_wallet_destination_type;
    },
    payInfo() {
      return this.payment?.[0];
    },
    hiddenRoutingNumber() {
      return this.data.payment_method.routing_number_id.replace(
        /\d(?=.*\d{4})/g,
        'X'
      );
    },
    brokerName() {
      return this.$store.state.brokers.logo?.legal_name;
    },
    opPaymentTerm() {
      return this.$store.state.carriers.carrierData?.payment_term;
    },
  },

  methods: {
    feesToText(paymentTerm) {
      if (!paymentTerm) return;
      let type = paymentTerm?.is_type;
      if (type === 'factoring') return;
      let discountRate = paymentTerm?.discount_rate * 100;
      if (discountRate?.toString()?.length > 4) {
        discountRate = discountRate?.toFixed(2) + '%';
      } else {
        discountRate = discountRate + '%';
      }

      let daysToPay = parseInt(paymentTerm?.days_to_pay);
      return (
        daysToPay +
        (daysToPay == 1 ? ' Day, ' : ' Days, ') +
        (paymentTerm?.discount_rate ? discountRate : 'No') +
        ' Fee'
      );
    },
    getMethod(method) {
      switch (method) {
        case 'ach':
          return 'ACH Deposit';
        case 'wire':
          return 'Wire Transfer';
        case 'check':
          return 'Check';
        default:
          return '';
      }
    },
    togglePaymentSource(e) {
      console.log('comes here!7');

      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'TriumphPay #1',
      });
      this.$store.dispatch('payments/updateNestedField', {
        path: 'payment_source',
        value: e.target.value,
      });
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'TriumphPay #2',
      });
    },
  },
  // watch: {
  //     stepName: async function (val) {
  //         if (val === "Payment-2" && this.paymentType === "factoring") {
  //             setTimeout(() => {
  //                 const findAutoCompleteInput = document.querySelector(
  //                     "#factoring_companies_input"
  //                 );
  //                 if (findAutoCompleteInput) {
  //                     findAutoCompleteInput.focus();
  //                 }
  //             }, 0);
  //         }
  //         if (val === "Payment-2" && !this.data.factor && this.latest_factor?.length > 0 && this.data.payment_term_id) {
  //             let payload = {};
  //             payload.body = {
  //                 "onboarding_packet": {
  //                     "payment_term_id": this.paymentTermId,
  //                     "factor_id": this.latest_factor[0].id
  //                 }
  //             }
  //             this.$store.commit('addFormDebugMessage', "AUTO PACKET UPDATE | TriumphPay: (stepName watcher) Commented-out but logging in case this gets used ");
  //             await this.$store.dispatch("onboardingPacket/updatePacket", payload);
  //             this.$store.commit("toggleDisabledButton", false);
  //         }
  //         if (val === "Payment-2" && this.data.factor && !this.data.payment_term_id) {
  //             let payload = {};
  //             payload.body = {
  //                 "onboarding_packet": {
  //                     "payment_term_id": this.paymentTermId,
  //                 }
  //             }
  //             this.$store.commit('addFormDebugMessage', "AUTO PACKET UPDATE | TriumphPay: (stepName watcher) Commented-out but logging in case this gets used ");
  //             await this.$store.dispatch("onboardingPacket/updatePacket", payload);
  //             this.$store.commit("toggleDisabledButton", false);
  //         }
  //         if (
  //             val === "Payment-2" &&
  //             ((this.data?.payment_term?.is_type === "factoring" && !this.data.factor) ||
  //                 (this.data?.payment_term?.is_type !== "factoring" &&
  //                     !this.data.payment_method))
  //         ) this.$store.commit("toggleDisabledButton", true);
  //         if (val === "Payment-2" && (this.editFactor || this.editPayme)) {
  //             this.$store.commit("toggleDisabledButton", true);
  //         }
  //     },
  // },
};
</script>
